var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.cookieInfo)?_c('div',{staticClass:"container mb-5",staticStyle:{"line-height":"24px"},domProps:{"innerHTML":_vm._s(_vm.getDescriptionByLang(_vm.cookieInfo))}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }